import { EpRadioGroup } from '../../../../components/EpRadioGroup';
import { EpErrorMessage, EpRadioButton } from '../../components';
import { useTranslation as t } from '../../../../hooks/useTranslation';
import { useFormContext } from 'react-hook-form';

const PatientOrFamilyKnow = ({ translations }: { translations: unknown }) => {
  const controller = 'patientOrFamilyKnow';
  const { formState: { errors } } = useFormContext();

  return (
    <>
      <EpRadioGroup
        legend={`${t(translations, 'Did the patient or family member notice the event?')} *`}
      >
        <EpRadioButton
          radioId={`EpRadio__yes`}
          radioValue={'true'}
          radioName={controller}
          radioLabel={t(translations, 'Yes')}
          required={true}
          errorMessage="* Required Fied"
          translations={translations}
          radioWithError={!!errors[controller]}
        />

        <EpRadioButton
          radioId={`EpRadio__no`}
          radioValue={'false'}
          radioName={controller}
          radioLabel={t(translations, 'No')}
          required={true}
          errorMessage="* Required Fied"
          translations={translations}
          radioWithError={!!errors[controller]}
        />

        <EpRadioButton
          radioId={`EpRadio__na`}
          radioValue={'NA'}
          radioName={controller}
          radioLabel={t(translations, 'N/A')}
          required={true}
          errorMessage="* Required Fied"
          translations={translations}
          radioWithError={!!errors[controller]}
        />
      </EpRadioGroup>

      <EpErrorMessage inputName={controller} />
    </>
  );
};

export default PatientOrFamilyKnow;
